import { put } from "@redux-saga/core/effects";
import {
  setAvailableFiles,
  setFilterTypes,
  GET_FILES,
} from "../../reducers/fileImportReducer";
import { handleError } from "../../../util/errorHandler";
import { getAPIConfig } from "../../../util/api-config";
import store from "../../configureStore";
import { FileImportApi } from "../../../generated/api";
import { toast } from "react-toastify";
import i18n from "../../../i18n/i18n";

function setUpClient() {
  return new FileImportApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleImportCards(action: any): any {
  try {
    const fileImportClient = setUpClient();
    yield fileImportClient.importCards(action.fileImportDTO);
    toast.success(String(i18n.t("fileImport.startedImport")));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleImportTransactions(action: any): any {
  try {
    const fileImportClient = setUpClient();
    yield fileImportClient.importTransactions(action.fileImportDTO);
    toast.success(String(i18n.t("fileImport.startedImport")));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleImportDeleteTransactions(action: any): any {
  try {
    const fileImportClient = setUpClient();
    yield fileImportClient.deleteTransactions(action.fileImportDTO);
    toast.success(String(i18n.t("fileImport.startedImport")));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleFilterTypes(action: any): any {
  try {
    const fileImportClient = setUpClient();
    const response = yield fileImportClient.getFilterTypes(action.importType);
    const filterTypes: String[] = response;
    yield put(setFilterTypes(filterTypes));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleFileUpload(action: any): any {
  try {
    const fileImportClient = setUpClient();
    yield fileImportClient.uploadFile(action.params);
    yield put({ type: GET_FILES });
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleGetFiles(action: any): any {
  try {
    const fileImportClient = setUpClient();
    const response = yield fileImportClient.getFiles();
    const availableFiles: String[] = response;
    yield put(setAvailableFiles(availableFiles));
  } catch (error: any) {
    yield handleError(error);
  }
}
